import AOS from 'aos';
import 'aos/dist/aos.css';
(function($)
{
    AOS.init({
        //startEvent: 'load', // load
        offset: 60, // offset (in px) from the original trigger point
        duration: 1200, // values from 0 to 3000, with step 50ms
        once: false, // whether animation should happen only once - while scrolling down
        mirror: false, // whether elements should animate out while scrolling past them
    });
    // setTimeout(() => {
    //     window.addEventListener('load', AOS.refresh());
    // }, 200);

    // Developments Map filter
    var $developmentsMapStatusFilter = $('.development-status-filter-js');
    if( $developmentsMapStatusFilter.length ) {
        $developmentsMapStatusFilter.on('change', function(){
            setTimeout(() => {
                AOS.refresh(); // refresh element pos checks
            }, 400);
        });
    }
    

    var scrolled = false;

    $(window).on('scroll',function() {

        //if I scroll more than 1000px...
        if($(window).scrollTop() > 0 && scrolled == false){
            $('body').addClass('page-scrolled');
            scrolled = true;
        } else if($(window).scrollTop() == 0) {
            $('body').removeClass('page-scrolled');
            scrolled = false;
        }
    });
    // Document ready
    $(function(){

        // Navbar Toggle
        $('.navbar-toggle').on('click',function(){
            var target = $(this).data('target');

            if( $(target).hasClass('show') ) {
                $(target).removeClass('show');
            } else {
                $(target).addClass('show');
            }
        });
    });

    // Development sales status redirect
    var $navDevStatus = $('.development-status-redirect-filter-js');
    if ( $navDevStatus.length ) {
        // Select2 - Open
        $navDevStatus.on("select2:open", function (e) { 
            // Remove default value
            $(e.currentTarget).val('');
        });
        // Select2 - Item selected 
        $navDevStatus.on("select2:select", function (e) { 
            var select_val = $(e.currentTarget).val();
            var pageRedirect = $(e.currentTarget).data('redirect');
            var devStatus = ( select_val == 'all') ? '' : '?devstatus='+select_val;
            // redirect to page
            window.location.replace(pageRedirect+devStatus);
        });
    }

})(jQuery);
